import { render, staticRenderFns } from "./HomeIdeasPlace.vue?vue&type=template&id=69be60f8&scoped=true"
import script from "./HomeIdeasPlace.vue?vue&type=script&lang=ts"
export * from "./HomeIdeasPlace.vue?vue&type=script&lang=ts"
import style0 from "./HomeIdeasPlace.vue?vue&type=style&index=0&id=69be60f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69be60f8",
  null
  
)

export default component.exports